import { useEffect, useState } from "react";
import { onSnapshot } from "firebase/firestore";
import { getDb } from "@/lib/firebase/client";
import { paths, refDoc } from "@/lib/db/paths";
import { householdSchema, type Household } from "@/lib/schemas";

const cache = new Map<string, Household>();

export function useHousehold(hid: string | undefined): {
  household: Household | null;
  loading: boolean;
} {
  const cached = hid ? cache.get(hid) : undefined;
  const [household, setHousehold] = useState<Household | null>(cached ?? null);
  const [loading, setLoading] = useState(cached === undefined);

  useEffect(() => {
    if (!hid) return;
    const ref = refDoc(getDb(), paths.household(hid));
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (!snap.exists()) {
          setHousehold(null);
        } else {
          const parsed = householdSchema.safeParse({ id: snap.id, ...snap.data() });
          if (parsed.success) {
            cache.set(hid, parsed.data);
            setHousehold(parsed.data);
          }
        }
        setLoading(false);
      },
      () => setLoading(false),
    );
    return () => unsub();
  }, [hid]);

  return { household, loading };
}
